import { render, staticRenderFns } from "./YatirimciListesi.vue?vue&type=template&id=50a8dcf6&scoped=true&"
import script from "./YatirimciListesi.vue?vue&type=script&lang=js&"
export * from "./YatirimciListesi.vue?vue&type=script&lang=js&"
import style0 from "./YatirimciListesi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YatirimciListesi.vue?vue&type=style&index=1&id=50a8dcf6&lang=scss&scoped=true&"
import style2 from "./YatirimciListesi.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./YatirimciListesi.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a8dcf6",
  null
  
)

export default component.exports